import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

const Layout = () => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-transparent text-slate-100">
      <div className="pointer-events-none absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0d1626] via-[#111d2f] to-[#0a121f]" />
        <div className="absolute -top-40 left-[30%] h-96 w-96 rounded-full bg-cyan-400/20 blur-[160px]" />
        <div className="absolute bottom-[-10%] right-[-5%] h-[28rem] w-[28rem] rounded-full bg-indigo-500/15 blur-[160px]" />
        <div className="absolute inset-0 opacity-30">
          <div className="h-full w-full [background:radial-gradient(circle_at_1px,_rgba(148,163,184,0.08)_1px,_transparent_0)] [background-size:30px_30px]" />
        </div>
      </div>

      <Sidebar />

      <div className="relative z-10 lg:pl-64 flex flex-col min-h-screen">
        <main className="flex-1 px-4 py-8 sm:px-6 lg:px-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
